import { combineReducers } from 'redux';

import defaultSuggestions from './defaultSuggestions.ts';
import redirect from './redirect.ts';
import request from './request.ts';
import response from './response.ts';

export default combineReducers({ defaultSuggestions, redirect, request, response });
